// Driver proof photos on an order: separate pickup and delivery slots. Photos
// taken before the split with no recorded phase are shown as "Driver photo".

const formatTakenAt = (value) => {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleString([], {
    month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit',
  });
};

export const photoSrc = (url) =>
  url.startsWith('data:') || url.startsWith('http') ? url : `data:image/jpeg;base64,${url}`;

export const driverPhotos = (order) => {
  if (!order) return [];
  const photos = [];
  if (order.pickupImageUrl) {
    photos.push({ key: 'pickup', label: 'Pickup photo', url: order.pickupImageUrl, takenAt: formatTakenAt(order.pickupImageAt) });
  }
  if (order.deliveryImageUrl) {
    photos.push({ key: 'delivery', label: 'Delivery photo', url: order.deliveryImageUrl, takenAt: formatTakenAt(order.deliveryImageAt) });
  }
  if (!photos.length && order.imageUrl) {
    order.imageUrl.split('|||').map((u) => u.trim()).filter(Boolean).forEach((url, idx) => {
      photos.push({ key: `driver-${idx}`, label: 'Driver photo', url, takenAt: formatTakenAt(order.imageCapturedAt) });
    });
  }
  return photos;
};
